/**
 * Số trên badge tab "Đang tham gia".
 *
 * Ưu tiên ĐẾM CHÍNH DANH SÁCH ĐANG HIỂN THỊ, vì nó là thứ người dùng nhìn thấy:
 * con số từ hồ sơ (user.leagues) chỉ so ngày kết thúc nên còn đếm cả giải
 * Swiss/loại trực tiếp đã có nhà vô địch — API đã loại chúng khỏi tab này, và
 * badge 5 trên một danh sách 2 giải là bug đã gặp trên demo.
 *
 * Chỉ đếm được khi đang ở đúng tab đó, danh sách đã tải HẾT (không còn trang
 * sau), và KHÔNG có bộ lọc nào thu hẹp kết quả — lọc theo thể thức/khu vực/CLB
 * thì số hiển thị là số đã lọc, không phải tổng số giải đang tham gia. Các
 * trường hợp còn lại quay về ước lượng từ hồ sơ: lệch đôi chút vẫn hơn là
 * không có số nào.
 */
export const soGiaiDangThamGia = (
    {tab, listComplete, khongLoc, soDangHien, soTheoHoSo}:
    { tab: string; listComplete: boolean; khongLoc: boolean; soDangHien: number; soTheoHoSo: number },
) => (tab === 'joined' && listComplete && khongLoc ? soDangHien : soTheoHoSo);
